<template>
  <div class="tag-input">
    <div
      v-for="(tag,index) in tags"
      :key="tag"
      class="tag-input__tag"
    >
      {{ tag }}
      <span @click="removeTag(index)">x</span>
    </div>
    <base-autocomplete
      class="d-inline-block tag-auto-complete"
      id="groupTag"
      v-model="inputValue"
      :items="autoCompleteOptions"
      :autoclear="true"
      @change="addTag"
      @submit="addTag"
    />
  </div>
</template>
<script>
import BaseAutocomplete from '@/components/form/BaseAutocomplete.vue';

export default {
  name: 'TagInput',
  components: { BaseAutocomplete },
  props: {
    options: {
      type: Array,
      required: true,
    },
    tags: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      inputValue: '',
    //   tags: [],
    };
  },
  computed: {
    autoCompleteOptions() {
      return this.options
        .map((item) => ({
          name: item,
          value: item,
        }));
    },
  },
  methods: {
    addTag() {
      const val = this.inputValue.trim();
      if (val.length > 0) {
        this.tags.push(val);
        this.inputValue = '';
        this.$emit('change', this.tags);
      }
    },
    removeTag(index) {
      this.tags.splice(index, 1);
    },
    removeLastTag(event) {
      if (event.target.value.length === 0) {
        this.removeTag(this.tags.length - 1);
      }
    },
  },
};
</script>
<style scoped>
</style>
